var _linearGradient, _path, _linearGradient2, _path2, _path3, _linearGradient3, _path4, _path5, _path6, _linearGradient4, _path7, _linearGradient5, _path8, _linearGradient6, _path9, _path0, _path1, _linearGradient7, _path10, _linearGradient8, _path11, _path12, _path13, _linearGradient9, _path14, _path15, _linearGradient0, _path16, _linearGradient1, _path17, _path18, _linearGradient10, _path19, _linearGradient11, _path20, _linearGradient12, _path21, _path22, _path23, _path24, _path25, _path26, _linearGradient13, _path27, _path28, _path29, _g, _g2, _linearGradient14, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: 61.631,
    y1: 563.347,
    x2: 62.022,
    y2: 563.347,
    gradientTransform: "matrix(0 149.735 149.735 0 -84296.266 -9188.014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0994DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#127BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#127BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127BCA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-a)",
    d: "M45.288 49.559c4.417 13.507 6.09 37.601 19.006 37.601.982 0 1.977-.096 2.974-.286-11.74-2.737-13.132-26.569-20.297-38.912a61.601 61.601 0 00-1.683 1.597"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-b",
    gradientUnits: "userSpaceOnUse",
    x1: 61.705,
    y1: 563.34,
    x2: 62.095,
    y2: 563.34,
    gradientTransform: "matrix(0 153.551 153.551 0 -86442.719 -9435.969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0E76BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-b)",
    d: "M46.971 47.962c7.165 12.342 8.557 36.174 20.297 38.912a18.621 18.621 0 002.773-.749C59.502 80.961 56.59 57.819 48.453 46.678c-.492.41-.987.839-1.482 1.284"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14559A",
    d: "M57.294 40.623c-.98 0-1.977.096-2.977.286-2.612.493-5.268 1.618-7.944 3.321.73.722 1.427 1.547 2.081 2.448 2.723-2.259 5.427-3.928 8.12-4.932a18.177 18.177 0 013.029-.842 9.393 9.393 0 00-2.309-.281"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-c",
    gradientUnits: "userSpaceOnUse",
    x1: 67.486,
    y1: 564.985,
    x2: 67.876,
    y2: 564.985,
    gradientTransform: "matrix(0 -122.178 -122.178 0 69099.289 8331.043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1C63B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#33BDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BDF2",
    stopOpacity: 0.42
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-c)",
    d: "M78.268 81.366a47.16 47.16 0 003.24-2.84c-4.488-13.443-6.095-37.883-19.101-37.883-.93 0-1.868.087-2.804.26C71.45 43.85 72.968 69.625 78.268 81.366"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3092C4",
    d: "M59.604 40.904a9.355 9.355 0 00-2.311-.282l5.114.019c-.929 0-1.867.086-2.803.263"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1969BC",
    d: "M78.04 84.221a19.441 19.441 0 01-1.466-1.584c-2.188 1.549-4.368 2.724-6.533 3.489.771.376 1.578.656 2.436.829.664.136 1.353.206 2.075.206 2.431 0 4.353-.288 5.987-1.072-.9-.488-1.726-1.118-2.499-1.868"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-d",
    gradientUnits: "userSpaceOnUse",
    x1: 61.852,
    y1: 563.281,
    x2: 62.243,
    y2: 563.281,
    gradientTransform: "matrix(0 159.425 159.425 0 -89733.742 -9828.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#166AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#0798DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#0798DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0798DD"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-d)",
    d: "M56.573 41.748c10.611 5.55 11.534 30.684 20.001 40.889.568-.4 1.13-.824 1.691-1.271-5.3-11.741-6.815-37.519-18.66-40.463-1.011.189-2.02.469-3.032.845"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-e",
    gradientUnits: "userSpaceOnUse",
    x1: 61.975,
    y1: 563.367,
    x2: 62.366,
    y2: 563.367,
    gradientTransform: "matrix(0 169.528 169.528 0 -95443.742 -10473.372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#124379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1487CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1487CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#165197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#165197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165197"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-e)",
    d: "M48.453 46.678c8.137 11.141 11.049 34.284 21.588 39.448 2.166-.765 4.346-1.939 6.533-3.489-8.467-10.205-9.39-35.338-20.001-40.889-2.693 1.002-5.397 2.671-8.12 4.93"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-f",
    gradientUnits: "userSpaceOnUse",
    x1: 1006.454,
    y1: -1412.08,
    x2: 1008.771,
    y2: -1412.08,
    gradientTransform: "matrix(4.038 0 0 -4.038 -4028.633 -5649.283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33BDF2",
    stopOpacity: 0.698
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DACD8"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-f)",
    d: "M40.083 49.234c-1.275 2.883-2.578 6.674-4.152 11.621 3.131-4.413 6.253-8.214 9.357-11.295a33.873 33.873 0 00-1.382-3.606 46.113 46.113 0 00-3.823 3.28"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B74B1",
    d: "M45.037 45.121c-.374.268-.751.542-1.13.832.495 1.08.953 2.292 1.38 3.607a66.502 66.502 0 011.684-1.597 22.346 22.346 0 00-1.934-2.842"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#125A9E",
    d: "M46.373 44.229c-.445.282-.888.58-1.337.891.695.855 1.333 1.81 1.936 2.844.495-.448.989-.879 1.482-1.287-.654-.9-1.35-1.726-2.081-2.448"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-g",
    gradientUnits: "userSpaceOnUse",
    x1: 67.564,
    y1: 565.48,
    x2: 67.954,
    y2: 565.48,
    gradientTransform: "matrix(0 -119.018 -119.018 0 67408.578 8125.832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#136AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#59CAF5",
    stopOpacity: 0.549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CAF5",
    stopOpacity: 0.235
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-g)",
    d: "M118.751 39.594c-6.001 23.144-18.536 41.734-29.044 46.42h-.021l-.567.243-.069.027-.161.062-.072.03-.263.093-.108.038-.131.043-.126.044-.112.038-.224.068-.096.025-.151.041-.103.028-.165.043-.201.044c.475.175.97.264 1.503.264 9.965 0 20.013-17.858 36.638-47.556h-6.528l.001.005z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-h",
    gradientUnits: "userSpaceOnUse",
    x1: 998.231,
    y1: -1414.829,
    x2: 1006.826,
    y2: -1414.829,
    gradientTransform: "matrix(4.038 0 0 -4.038 -4028.633 -5649.283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05A1E6",
    stopOpacity: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-h)",
    d: "M33.766 41.563l.019-.016.023-.015h.013l.161-.062.032-.016.042-.017.173-.062h.009l.383-.134.057-.015.164-.049.075-.024.165-.049.063-.017.548-.142.075-.017.16-.031.078-.024.161-.03h.038l.333-.062h.066l.154-.027.087-.015.147-.022.081-.016.358-.032a11.467 11.467 0 00-1.061-.054c-11.223 0-26.685 20.822-33.649 47.788h1.343a390.312 390.312 0 006.062-11.266c4.879-19.1 14.814-32.126 23.64-35.577"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D82CA",
    d: "M40.083 49.234a46.488 46.488 0 013.823-3.281 17.961 17.961 0 00-.911-1.761c-1.026 1.246-1.964 2.89-2.912 5.042"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D82CA",
    d: "M41.005 41.72c.733.614 1.39 1.46 1.99 2.473.189-.232.381-.447.58-.649a11.263 11.263 0 00-2.712-1.897l.12.057.022.016"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-i",
    gradientUnits: "userSpaceOnUse",
    x1: 67.491,
    y1: 564.359,
    x2: 67.881,
    y2: 564.359,
    gradientTransform: "matrix(0 -121.865 -121.865 0 68797.742 8310.488)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#318ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38A7E4"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-i)",
    d: "M10.127 77.138c10.233-19.719 15.081-32.199 23.64-35.577-8.825 3.454-18.762 16.479-23.64 35.577"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#127BCA",
    d: "M43.574 43.544c-.199.204-.389.417-.58.649.322.538.621 1.124.913 1.76.378-.29.756-.563 1.129-.832a15.351 15.351 0 00-1.462-1.577"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-j",
    gradientUnits: "userSpaceOnUse",
    x1: 67.593,
    y1: 564.41,
    x2: 67.984,
    y2: 564.41,
    gradientTransform: "matrix(0 -118.46 -118.46 0 66884.703 8093.017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6",
    stopOpacity: 0.549
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-j)",
    d: "M14.773 88.315l-.186.022h-.035l-.158.016h-.026l-.376.025h-.039c10.356-.29 15.091-5.475 17.44-12.997 1.785-5.701 3.252-10.505 4.537-14.535-4.338 6.106-8.696 13.384-13.077 21.539-2.112 3.93-5.325 5.572-8.08 5.922"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-k",
    gradientUnits: "userSpaceOnUse",
    x1: 68.291,
    y1: 564.525,
    x2: 68.682,
    y2: 564.525,
    gradientTransform: "matrix(0 -100.1 -100.1 0 56536.551 6924.301)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#7EC5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EC5EA"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-k)",
    d: "M14.773 88.311c2.755-.351 5.968-1.991 8.08-5.923 4.381-8.151 8.741-15.431 13.075-21.538 1.577-4.949 2.878-8.737 4.154-11.621-8.639 8.223-17.311 21.896-25.31 39.077"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#05A1E6",
    d: "M10.127 77.139a388.004 388.004 0 01-6.063 11.266h3.904a95.502 95.502 0 012.158-11.264"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-l",
    gradientUnits: "userSpaceOnUse",
    x1: 67.892,
    y1: 563.82,
    x2: 68.282,
    y2: 563.82,
    gradientTransform: "scale(-110.211 110.211) rotate(-80 -301.688 322.91)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#165096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D82CA"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-l)",
    d: "M37.073 40.709l-.083.016-.146.021-.086.015-.154.027-.066.016-.333.058h-.038l-.162.032-.081.022-.157.031-.074.018-.549.142-.063.018-.166.049-.075.021-.163.049-.06.016-.381.134-.173.06-.072.03-.161.06-.054.026c-8.558 3.377-13.406 15.857-23.639 35.576A94.655 94.655 0 007.979 88.41h.547l3.755-.016h1.723l.375-.025h.024l.158-.016h.037l.186-.022c8-17.182 16.672-30.854 25.31-39.077.95-2.152 1.887-3.796 2.911-5.04-.6-1.013-1.256-1.861-1.988-2.476l-.021-.016-.122-.059-.121-.061-.117-.057-.139-.058-.108-.047-.227-.095-.097-.036-.169-.068-.091-.03-.235-.081h-.019l-.272-.077-.061-.019-.229-.064-.053-.015a7.851 7.851 0 00-.569-.125l-.059-.016-.247-.04-.049-.015-.292-.039h-.051l-.226-.025-.358.033"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-m",
    gradientUnits: "userSpaceOnUse",
    x1: 70.847,
    y1: 566.882,
    x2: 71.237,
    y2: 566.882,
    gradientTransform: "matrix(0 -56.721 -56.721 0 32252.127 4080.282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#0495D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0495D6"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-m)",
    d: "M95.311 52.407c-1.97 6.307-3.563 11.51-4.952 15.791 5.403-7.435 10.725-16.787 15.792-27.579-5.913 1.857-9.065 6.107-10.84 11.788"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-n",
    gradientUnits: "userSpaceOnUse",
    x1: 61.634,
    y1: 562.213,
    x2: 62.024,
    y2: 562.213,
    gradientTransform: "scale(-132.813 132.813) rotate(80 365.248 244.034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38A7E4",
    stopOpacity: 0.329
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#0E88D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#0E88D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E88D3"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-n)",
    d: "M90.53 85.621c-.275.14-.552.273-.823.394 10.508-4.687 23.044-23.277 29.044-46.421h-1.216c-13.788 24.631-18.222 41.12-27.005 46.027"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#079AE1",
    d: "M83.668 83.552c2.287-2.791 4.148-7.535 6.691-15.354-2.933 4.029-5.885 7.492-8.84 10.316l-.015.025c.645 1.931 1.352 3.636 2.158 5.012"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#1969BC",
    d: "M83.668 83.552c-.778.95-1.603 1.673-2.519 2.209-.2.117-.404.227-.61.327a8.839 8.839 0 003.206 1.011l.524.046h.031l.252.016h.855l.097-.016.189-.016h.092l.205-.022h.017l.063-.015.219-.034h.064l.246-.041h.04l.491-.104c-1.357-.496-2.492-1.667-3.469-3.334"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E5CB3",
    d: "M64.295 87.161c.982 0 1.976-.096 2.973-.288a18.309 18.309 0 002.773-.747c.771.376 1.579.656 2.435.831.664.135 1.354.205 2.077.205H64.295zM74.553 87.161c2.429 0 4.353-.288 5.986-1.073a8.84 8.84 0 003.206 1.012l.524.045h.031l.252.016h.302-10.301z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D60B5",
    d: "M84.854 87.161h.561l.097-.016.191-.016h.092l.204-.022h.017l.062-.016.219-.033.067-.015.247-.04h.039l.491-.104c.475.175.97.264 1.503.264l-3.788.016-.002-.018z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#175FAB",
    d: "M81.511 78.54v-.016a47.16 47.16 0 01-3.24 2.84 36.81 36.81 0 01-1.693 1.271c.476.568.959 1.1 1.468 1.585.772.749 1.597 1.38 2.498 1.867.205-.101.41-.211.609-.327.918-.536 1.741-1.26 2.52-2.209-.806-1.376-1.513-3.082-2.157-5.012"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-o",
    gradientUnits: "userSpaceOnUse",
    x1: 61.149,
    y1: 562.654,
    x2: 61.539,
    y2: 562.654,
    gradientTransform: "matrix(0 123.742 123.742 0 -69523.625 -7527.189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#168CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C87CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154B8D"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-o)",
    d: "M113.685 39.594h-6.121l-.97.047-.451.966c-5.068 10.793-10.388 20.145-15.791 27.58-2.54 7.818-4.404 12.563-6.69 15.353.977 1.668 2.114 2.84 3.466 3.337l.106-.023h.022l.075-.016.17-.042.101-.029.151-.039.094-.027.226-.068.112-.038.126-.046.13-.041.106-.04.264-.093.073-.027.162-.063.068-.025.568-.243h.02c.271-.119.547-.254.821-.394 8.785-4.908 13.22-21.396 27.008-46.026h-3.851l.005-.003z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#7DCBEC",
    d: "M37.433 40.677l.063.016.16.017h.054l.292.038.049.016.246.041.062.015.567.126.052.016.228.064.063.019.271.077.021.016.237.081.09.029.17.069.096.034.226.094.11.047.136.059.12.057.119.062c.979.48 1.879 1.121 2.713 1.898.308-.323.628-.613.962-.874-1.823-1.293-3.89-2.03-6.271-2.03-.276 0-.552.016-.832.037"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EC5ED",
    d: "M43.574 43.544c.511.475 1 1.005 1.462 1.577.448-.311.892-.611 1.337-.891a14.13 14.13 0 00-1.839-1.56c-.333.26-.652.552-.96.874"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.048 0 0 -5.048 -9064.26 2270.61)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-p",
    gradientUnits: "userSpaceOnUse",
    x1: 1806.96,
    y1: 336.158,
    x2: 1807.35,
    y2: 336.158,
    gradientTransform: "scale(30.857 -30.857) rotate(22.527 1812.675 -4228.953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#55C1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1EA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-p)",
    d: "M1802.977 441.733l.165.007c.472 0 .881-.146 1.242-.402.381.301.842.406 1.482.406h-3.099l.21-.011"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.048 0 0 -5.048 -9064.26 2270.61)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-q",
    gradientUnits: "userSpaceOnUse",
    x1: 1808.848,
    y1: 335.171,
    x2: 1809.238,
    y2: 335.171,
    gradientTransform: "scale(24.717 -24.717) rotate(-24.385 124.122 4175.416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ACCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB7ED"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-q)",
    d: "M1805.866 441.744c-.64 0-1.1-.105-1.482-.406.126-.089.248-.193.364-.309.531.337 1.056.561 1.574.658.198.037.395.056.589.056h-1.045v.001z"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-r",
    gradientUnits: "userSpaceOnUse",
    x1: 61.049,
    y1: 562.706,
    x2: 61.439,
    y2: 562.706,
    gradientTransform: "matrix(0 121.032 121.032 0 -68011.711 -7346.748)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1DA7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ABE7",
    stopOpacity: 0
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-r)",
    d: "M90.359 68.202c1.391-4.284 2.98-9.485 4.954-15.794 1.777-5.684 4.925-9.934 10.835-11.788l.456-.966c-9.636.577-14.14 5.479-16.405 12.738-3.964 12.673-6.365 20.888-8.677 26.123 2.952-2.823 5.904-6.288 8.837-10.313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/NET.ab2b205a2693223d20eadbd57ff967a0.svg";
export { ForwardRef as ReactComponent };